import * as React from 'react'
require('../base.module.scss')
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import * as st from './Spacer.module.scss'


export enum spacerSpacing {
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
}

export enum spacerAlignItems {
  top = 'top',
  bottom = 'bottom',
  center = 'center',
  baseline = 'baseline',
  stretch = 'stretch'
}

export interface SpacerProps extends BaseComponentProps {
    space?: spacerSpacing,
    alignItems?: spacerAlignItems
    className?: string
   }

export const Spacer: React.ComponentType<SpacerProps> = (props: SpacerProps) => {
  const space = spacerSpacing[props.space || spacerSpacing.xs]
  const alignItems = spacerAlignItems[props.alignItems || spacerAlignItems.baseline]
  const className = extractClassNamesFromProps(
    props,
    st[space],
    st[alignItems],
    st.spacer
  )

  return <div className={className}>{props.children}</div>
}

// Add displayName to preserve the component name on snapshot testing
Spacer.displayName = 'Spacer'
